<template>
  <page-container
    primary
    title="Showcase"
  >
    <v-row>
      <v-col
        class="subheading"
        cols="12"
      >
        Op deze pagina vindt u een selectie van projecten die wij in het verleden
        hebben gerealiseerd of bij betrokken zijn geweest:
      </v-col>

      <v-col
        v-for="(project, slug) in nonDraftCases"
        :key="slug"
        cols="12"
        sm="6"
        lg="4"
      >
        <v-hover>
          <v-card
            slot-scope="{ hover }"
            :to="localePath({name: 'showcase-slug', params: {slug: project.slug}})"
            class="rounded-card"
          >
            <v-img
              :src="project.contents.attributes.image"
              height="250px"
            >
              <v-expand-transition>
                <div
                  v-if="hover"
                  class="d-flex transition-fast-in-fast-out green
                    v-card--reveal display-3 white--text px-3"
                  :style="{height: project.contents.attributes.icons?'70%':'50%'}"
                >
                  <div>
                    <h3 class="title mb-1">
                      {{ project.contents.attributes.title }}
                    </h3>
                    <div class="body-1">
                      {{ project.contents.attributes.summary }}
                    </div>
                    <div
                      v-if="project.contents.attributes.icons"
                      class="my-0 py-0"
                    >
                      <v-tooltip
                        v-for="(icon, i) in project.contents.attributes.icons.split(',')"
                        :key="i"
                        bottom
                      >
                        <template v-slot:activator="{ on }">
                          <v-avatar
                            size="40"
                            class="my-0 py-0 mr-2"
                            color="indigo"
                            v-on="on"
                          >
                            <v-icon dark>
                              {{ icon.trim() }}
                            </v-icon>
                          </v-avatar>
                        </template>
                        <span>{{ glossary[icon.trim()] }}</span>
                      </v-tooltip>
                    </div>
                  </div>
                </div>
              </v-expand-transition>
            </v-img>
            <v-card-title class="grey lighten-4">
              <v-spacer />
              <span class="title">{{ project.contents.attributes.client }}</span>
              <v-spacer />
            </v-card-title>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>
  </page-container>
</template>

<script>
import { getBreadcrumbSchema } from '../../assets/js/util'
import PageContainer from '@/components/PageContainer'
import { sortBy } from 'lodash'

export default {
  components: {
    PageContainer
  },
  async asyncData ({ app, params, store }) {
    const lang = app.i18n.locale
    const cases = []

    for (const aCase of store.state.content.cases[lang]) {
      cases.push({
        contents: await import(`../../content/showcase/${lang}/${aCase.slug}.md`),
        ...aCase
      })
    }
    return {
      cases
    }
  },
  data: () => ({
    glossary: {
      'mdi-store': 'Schappenonderzoek',
      'mdi-eye-settings': 'Eye-tracking',
      'mdi-web': 'Online onderzoek',
      'mdi-format-list-bulleted-type': 'Vragenlijst'
    }
  }),
  computed: {
    language () {
      return this.$i18n.locale
    },
    nonDraftCases () {
      return sortBy(
        this.cases.filter(aCase => !aCase.contents.attributes.draft),
        'ctimeMs'
      ).reverse()
    }
  },
  head () {
    const title = 'Showcase'
    return {
      title,
      script: [getBreadcrumbSchema(this.$route.path, title)]
    }
  }
}
</script>

<style scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .9;
  position: absolute;
  width: 100%;
}
</style>